<template lang="pug">
    div(:class="{ _con: reset, _page: page, _row: row }")
        slot
</template>

<script>
    /**
     * This component resets all text formatting styles to their initial values.
     */
    export default {
        name: 'ib-context',

        props: {
            /**
             * If true, reset CSS formatting to initial state; this prevents formatting from
             * the parent context from affecting this context. By default, this is true.
             */
            reset: {
                type: Boolean,
                default: true
            },
            /** @ignore - deprecated */
            page: Boolean,
            /** @ignore - deprecated */
            row: Boolean
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._con {
        font: initial;
        font-family: @font-family;
        .font-size(@fs6);
        .line-height-auto(@fs6);
        color: @fg;
        letter-spacing: initial;
        text-align: initial;
        text-align-last: initial;
        text-indent: initial;
        text-justify: initial;
        text-shadow: initial;
        white-space: initial;
        word-break: initial;
        word-spacing: initial;
        word-wrap: initial;
        float: initial;

        &._page {
            position: relative;
            margin: 0 auto;
            width: 100%;
            height: 100%;
        }
    }
</style>
